import { I18n } from '@/scenarios/profiles/hooks/useI18n';

interface GetProfileSubText {
    i18n: I18n;
    isAdmin?: boolean;
    isAuthorized: boolean;
    isMasterProfile?: boolean;
    parentalControlEnabled?: boolean;
    ageRestrictionGroup?: string;
}

function getUserProfileSubtitle({
    i18n,
    isAuth = true,
    isAdmin = false,
    ageRestriction = '',
}: {
    i18n: I18n;
    isAuth?: boolean;
    isAdmin?: boolean;
    ageRestriction?: string;
}) {
    if (!isAuth) {
        return i18n('profiles_not_loggin');
    }

    if (isAdmin) {
        return i18n('profiles_administrator');
    }

    if (ageRestriction) {
        return ageRestriction;
    }

    return undefined;
}

export function getProfileSubText({
    i18n,
    isAdmin,
    isAuthorized,
    isMasterProfile,
    parentalControlEnabled,
    ageRestrictionGroup,
}: GetProfileSubText) {
    if (isAdmin || !isAuthorized || (isMasterProfile && ageRestrictionGroup !== undefined)) {
        return getUserProfileSubtitle({
            i18n,
            isAuth: isAuthorized,
            isAdmin,
            ageRestriction: ageRestrictionGroup ?? '',
        });
    }

    if (parentalControlEnabled) {
        return i18n('profile_subtext__restricted');
    }
    if (!isMasterProfile && ageRestrictionGroup !== undefined) {
        return ageRestrictionGroup;
    }
}
